const addHiddenField = (form: HTMLFormElement, name: string, value: string) => {
	const input = document.createElement("input");
	input.type = "hidden";
	input.name = name;
	input.value = value;
	form.appendChild(input);
};

/**
 * Submits a native form to Hostopia, using hidden inputs.
 * @param username
 * @param password
 */
export const submitFormToHostopia = (username: string, password: string) => {
	const runtimeConfig = useRuntimeConfig();

	const form = document.createElement("form");
	form.method = "POST";
	form.action = runtimeConfig.public.hostopia.formLoginUrl;

	addHiddenField(form, "user", username);
	addHiddenField(form, "password", password);
	addHiddenField(form, "CustomError", window.location.origin + window.location.pathname + "?loginError=1");
	addHiddenField(form, "CustomLogin", window.location.origin + window.location.pathname);

	document.body.appendChild(form);
	form.submit();
};

function toCamelCase(str) {
	str = str || "";
	return str
		.toLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}
export function formattedAccountName(account = { firstName: "", lastName: "" }) {
	const { firstName, lastName } = account;
	return toCamelCase(`${firstName} ${lastName}`);
}
